module.exports = __webpack_public_path__ + "img/Partner_CMC.9657d3bf.svg";